import script from "./BaseInputText.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseInputText.vue?vue&type=script&setup=true&lang=ts"

import "./BaseInputText.vue?vue&type=style&index=0&id=946f9712&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-946f9712"]])

export default __exports__